
import React from 'react';
import Icon from 'react-icon-base';

const DmiError = props => (
  <Icon viewBox="0 0 22 19" {...props}>
    <g>
      <g fill="none" fillRule="evenodd">
        <path d="M-1 0h24v24H-1z" />
        <path fill="currentColor" fillRule="nonzero" d="M0 19h22L11 0 0 19zm12-3h-2v-2h2v2zm0-4h-2V8h2v4z" />
      </g>
    </g>
  </Icon>
);

export default DmiError;
